<template>
  <ld-json :json="jsonld" />
</template>

<script setup lang="ts">
import { LdJson } from 'atoms';
import { computed } from 'vue';

import { useCatalogTextList } from '@/composables/catalogTextList';
import { useFischer } from '@/composables/fischerPlugin';

defineOptions({ name: 'ProductDetailSchemaFi' });

const props = withDefaults(
  defineProps<{
    catalogData?: Record<string, any> | null;
  }>(),
  {
    catalogData: null,
  },
);

const fischer = useFischer();
const { textListValue } = useCatalogTextList();

const jsonld = computed(() => {
  if (
    props.catalogData?.categoryData?.categoryName &&
    textListValue(props.catalogData?.TextList, 'ECOMLANG') &&
    fischer.brandName()
  ) {
    const categorySlug = `${fischer.hostUrlBase()}${fischer.pages.products().url}${props.catalogData.categoryData.Slug}`;

    return JSON.stringify({
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: textListValue(props.catalogData.TextList, 'ECOMLANG'),
      url: `${fischer.hostUrlBase()}${fischer.pages.products().url}${props.catalogData.Slug}`,
      productID: props.catalogData.ProductId,
      image: props.catalogData.Media?.[0]?.Url,
      description: textListValue(props.catalogData.TextList, 'DOKBSTMARKDESCR'),
      brand: {
        '@type': 'Brand',
        name: fischer.brandName(),
      },
      isVariantOf: {
        '@type': 'ProductGroup',
        '@id': categorySlug,
        name: props.catalogData.categoryData.categoryName,
        url: categorySlug,
        image: props.catalogData.categoryData.categoryMedia,
      },
    });
  }

  return null;
});
</script>
